import React from 'react';
import { useTranslate } from 'react-admin';

import Alert from '@material-ui/lab/Alert';

import { HeadTransaction } from '~/types/HeadTransaction';
import { TransactionStatus } from '~/types/TransactionStatus';

const l = (key: string): string => `components.TransactionResultAlert.${key}`;

const severity = (status: TransactionStatus) => {
  switch (status) {
    case 'COMPLETED':
      return 'success';
    case 'REJECTED':
      return 'error';
    default:
      return 'info';
  }
};

type TransactionResultAlertProps = {
  transaction: HeadTransaction;
  successMessage?: string;
};

const TransactionResultAlert = ({ transaction, successMessage }: TransactionResultAlertProps) => {
  const translate = useTranslate();
  const t = (key: string, options?: any): string => translate(l(key), options);

  const statusMessage = (status: TransactionStatus): string => {
    switch (status) {
      case 'COMPLETED':
        return successMessage || t('completed');
      case 'AWAITING_APPROVAL':
        return t('awaitingApproval');
      case 'REJECTED':
        return t('rejected');
      default:
        return t('other', {
          status: translate(`components.ra.fields.StatusField.${status}`, { _: status }),
        });
    }
  };

  return <Alert severity={severity(transaction.status)}>{statusMessage(transaction.status)}</Alert>;
};

export default TransactionResultAlert;
